/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Amount } from "./Amount";
import { JiffyInfoPsp } from "./JiffyInfoPsp";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum LinguaEnum {
  "IT" = "IT",

  "EN" = "EN",

  "FR" = "FR",

  "DE" = "DE",

  "SL" = "SL"
}

// required attributes
const PspR = t.interface({});

// optional attributes
const PspO = t.partial({
  appChannel: t.boolean,

  businessName: t.string,

  cancelled: t.boolean,

  codiceAbi: t.string,

  codiceConvenzione: t.string,

  favoriteSellerCharge: t.Integer,

  fixedCost: Amount,

  flagStamp: t.boolean,

  id: t.Integer,

  idCard: t.Integer,

  idChannel: t.string,

  idIntermediary: t.string,

  idPsp: t.string,

  isCancelled: t.boolean,

  isDirectAcquirer: t.boolean,

  isPspOnus: t.boolean,

  jiffyInfoPsp: JiffyInfoPsp,

  lingua: enumType<LinguaEnum>(LinguaEnum, "lingua"),

  logoPSP: t.string,

  participant: t.string,

  paymentModel: t.Integer,

  paymentType: t.string,

  serviceAvailability: t.string,

  serviceDescription: t.string,

  serviceLogo: t.string,

  serviceName: t.string,

  solvedByPan: t.boolean,

  tags: t.readonlyArray(t.string, "array of string"),

  urlInfoChannel: t.string
});

export const Psp = t.intersection([PspR, PspO], "Psp");

export type Psp = t.TypeOf<typeof Psp>;
